import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
            position: 'top',
        },
        title: {
            display: false,
            text: 'Chart.js Bar Chart',
        },
    },
};

export function GraficaPerdidas({ valores, labels=[], label=""}) {
    const data = {
        labels,
        datasets: [
            {
                label,
                data: valores,
                backgroundColor: '#009bdb',
            },
        ],
    };
    return <Bar options={options} data={data} />;
}